// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2xmix","name":"ConsentHeader_name__2ycwi","birthday":"ConsentHeader_birthday__34g81","skeleton":"ConsentHeader_skeleton__3RqLv"};